/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Party_Label_One_InfantInputs */

const en_party_label_one_infant = /** @type {(inputs: Party_Label_One_InfantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1 infant`)
};

/**
* | output |
* | --- |
* | "1 infant" |
*
* @param {Party_Label_One_InfantInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const party_label_one_infant = /** @type {((inputs?: Party_Label_One_InfantInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Party_Label_One_InfantInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_party_label_one_infant(inputs)
});